module.exports = __webpack_public_path__ + "img/921-f23a98.png";